// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"212eebff","171":"541c4a8c","297":"b8b3f121","355":"56b19da0","385":"9099ffe7","529":"b1c030f0","924":"0b300475"}[chunkId] + ".chunk.js";
};